import React from 'react'
import { Button } from 'react-bootstrap'
import Lottie from 'react-lottie';
import animation404 from "../../assets/animations/404page.json";
import "./NotFoundPage.css";
import { useNavigate } from 'react-router-dom';

export const NotFoundPage = () => {
  const navigate = useNavigate();

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animation404,
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        maxHeight: '100vh',
        overflowY: 'scroll',
        justifyContent: 'center',
        position: 'relative', 
      }}
    >
      <div className="d-flex card-section">
        <div className='content'>
          <Lottie options={defaultOptions} width={400} height={400} />
          <h2 className='text'>Oops, la página solicitada no ha sido encontrada o no existe.</h2>
          <Button
            style={{ background: "#0E273C" }}
            className='btn-back'
            size="sm"
            onClick={() => { navigate("/") }}
          >
            Regresar
          </Button>
        </div>

      </div>
    </div>
  );
}